import { Li, List } from '@collab/atoms';

import createText from 'libs/notion-renderer/createText';
import { NotionProps } from 'notion/types';

const NotionList: React.FC<NotionProps> = ({ block: { variant, items } }) => {
  const listItems = items.map((item: any) => (
    <Li key={item.id}>{createText(item.text)}</Li>
  ));

  return <List as={variant}>{listItems}</List>;
};

export default NotionList;
